export default {"src":"/_next/static/media/play-transparent-icon.8c850483.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};